import React, { Component } from 'react';
import { List, WhiteSpace, Modal, Toast, Flex, Button, NavBar } from 'antd-mobile';
import F2 from '@antv/f2';
import df from 'dateformat';
import { ROOT_PATH } from '../../config';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';
import Table from '../../components/Table';
import CostAnalysisDetail from './costAnalysisDetail';
import EmptyReport from '../../components/EmptyReport';
import DatePicker from '../../components/DatePicker';
import auth from '../../utils/auth';
import send from '../../utils/send';
import FarmLess from '../../components/farmLess';

const today = new Date();
let clientWidth = document.documentElement.clientWidth;
let canvasHeight = 365;
let already = 0;
let stageToColor = {
  落地成本: '#1890FF',
  断奶成本: '#31C0B0',
  保育阶段成本: '#897DEC',
  育成阶段成本: '#FE5578'
};
class CostAnalysis extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showWarning: false,
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      startDate: today,
      endDate: today,
      dateExtra: '',
      hasStageCostData: true,
      hasStockCostaData: true,
      hasSellCostData: true,
      data1: [],
      data2: [],
      data3: [],
      columns1: [
        {
          id: 'item',
          title: '项目',
          align: 'left',
          render: (data, index, item) => {
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  if (window.$farmFlag && Number(window.$farmFlag) === 15) {
                    this.setState({
                      showWarning: true
                    });
                  } else {
                    this.setState({
                      modalShow: true,
                      modalContent: <CostAnalysisDetail data={data} />
                    });
                  }
                }}
              >
                {data.item}
              </span>
            );
          }
        },
        {
          id: 'qty',
          title: '数量',
          align: 'right'
        },
        {
          id: 'weight',
          title: '重量',
          align: 'right'
        },
        {
          id: 'avarage',
          title: '均重',
          align: 'right'
        },
        {
          id: 'price',
          title: '单位(元/头)',
          align: 'right'
        }
      ],
      columns2: [
        {
          id: 'item',
          title: '项目',
          align: 'left',
          render: (data, index, item) => {
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  if (window.$farmFlag && Number(window.$farmFlag) === 15) {
                    this.setState({
                      showWarning: true
                    });
                  } else {
                    this.setState({
                      modalShow: true,
                      modalContent: <CostAnalysisDetail data={data} />
                    });
                  }
                }}
              >
                {data.item}
              </span>
            );
          }
        },
        {
          id: 'initial_stock',
          title: '期初存栏',
          align: 'right'
        },
        {
          id: 'initial_cost',
          title: '期初成本',
          align: 'right'
        },
        {
          id: 'final_stock',
          title: '期末存栏',
          align: 'right'
        },
        {
          id: 'final_cost',
          title: '期末成本',
          align: 'right'
        }
      ],
      columns3: [
        {
          id: 'item',
          title: '项目',
          align: 'left',
          render: (data, index, item) => {
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  if (window.$farmFlag && Number(window.$farmFlag) === 15) {
                    this.setState({
                      showWarning: true
                    });
                  } else {
                    this.setState({
                      modalShow: true,
                      modalContent: <CostAnalysisDetail data={data} />
                    });
                  }
                }}
              >
                {data.item}
              </span>
            );
          }
        },
        {
          id: 'qty',
          title: '数量',
          align: 'right'
        },
        {
          id: 'weight',
          title: '重量',
          align: 'right'
        },
        {
          id: 'price_one',
          title: '单位(元/头)',
          align: 'right'
        },
        {
          id: 'price_kg',
          title: '单位(元/kg)',
          align: 'right'
        }
      ],
      showCostAccount: false, // 从成本核算来。要底部的button
      counting: false, // 是否正在核算中。
      current: '',
      resultMsg: []
    };
  }

  // 获取猪只阶段成本数据
  getStageCostData = (startDate, endDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/1/costAnalySisListCommand2`,
        qs.stringify({
          dateStart: startDate,
          dateEnd: endDate,
          gdType: 'D001101',
          gdCode: '1001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.parseStageCostData(res.data);
      })
      .catch((err) => {
        return err;
      });
  };

  // 获取猪只阶段成本表格数据
  getStageCostTableData(startDate, endDate) {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/costAnalySisListCommand1`,
        qs.stringify({
          dateStart: startDate,
          dateEnd: endDate,
          gdType: 'D001101',
          gdCode: '2001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.updateStageCostTable(res.data);
      })
      .catch((err) => {
        return err;
      });
  }

  updateStageCostTable(data) {
    let dataSource = [];
    data.map((obj) => {
      let newObj = {};
      newObj['item'] = obj.webReportDescLoc;
      newObj['qty'] = obj.val_1 !== undefined ? obj.val_1 : '-';
      newObj['weight'] = obj.val_2 !== undefined ? obj.val_2 : '-';
      newObj['avarage'] = obj.val_3 !== undefined ? obj.val_3 : '-';
      newObj['price'] = obj.val_4 !== undefined ? obj.val_4 : '-';
      newObj['gdType'] = obj.gdType;
      newObj['gdCode'] = obj.gdCode;
      newObj['startDate'] = df(this.state.startDate, 'yyyy-mm-dd');
      newObj['endDate'] = df(this.state.endDate, 'yyyy-mm-dd');
      dataSource.push(newObj);
    });
    this.setState({ data1: dataSource });
  }

  // 获取猪只期末库存单位成本数据
  getStockCostData = (startDate, endDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/1/costAnalySisListCommand2`,
        qs.stringify({
          dateStart: startDate,
          dateEnd: endDate,
          gdType: 'D001101',
          gdCode: '3001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.parseStockCostData(res.data);
      })
      .catch((err) => {
        return err;
      });
  };

  // 获取猪只期末库存成本表格数据
  getStockCostTableData(startDate, endDate) {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/costAnalySisListCommand1`,
        qs.stringify({
          dateStart: startDate,
          dateEnd: endDate,
          gdType: 'D001101',
          gdCode: '3002'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.updateStockCostTable(res.data);
      })
      .catch((err) => {
        return err;
      });
  }

  updateStockCostTable(data) {
    let dataSource = [];
    data.map((obj) => {
      let newObj = {};
      newObj['item'] = obj.webReportDescLoc;
      newObj['initial_stock'] = obj.val_1 !== undefined ? obj.val_1 : '-';
      newObj['initial_cost'] = obj.val_2 !== undefined ? obj.val_2 : '-';
      newObj['final_stock'] = obj.val_3 !== undefined ? obj.val_3 : '-';
      newObj['final_cost'] = obj.val_4 !== undefined ? obj.val_4 : '-';
      newObj['gdType'] = obj.gdType;
      newObj['gdCode'] = obj.gdCode;
      newObj['startDate'] = df(this.state.startDate, 'yyyy-mm-dd');
      newObj['endDate'] = df(this.state.endDate, 'yyyy-mm-dd');
      dataSource.push(newObj);
    });
    this.setState({ data2: dataSource });
  }

  // 获取猪只销售成本数据
  getSellCostData = (startDate, endDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/1/costAnalySisListCommand2`,
        qs.stringify({
          dateStart: startDate,
          dateEnd: endDate,
          gdType: 'D001101',
          gdCode: '4001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.parseSellCostData(res.data);
      })
      .catch((err) => {
        return err;
      });
  };

  // 获取猪只销售成本表格数据
  getSellCostTableData(startDate, endDate) {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/costAnalySisListCommand1`,
        qs.stringify({
          dateStart: startDate,
          dateEnd: endDate,
          gdType: 'D001101',
          gdCode: '4002'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.updateCellCostTable(res.data);
      })
      .catch((err) => {
        return err;
      });
  }

  updateCellCostTable(data) {
    let dataSource = [];
    data.map((obj) => {
      let newObj = {};
      newObj['item'] = obj.webReportDescLoc;
      newObj['qty'] = obj.val_1 !== undefined ? obj.val_1 : '-';
      newObj['weight'] = obj.val_2 !== undefined ? obj.val_2 : '-';
      newObj['price_one'] = obj.val_3 !== undefined ? obj.val_3 : '-';
      newObj['price_kg'] = obj.val_4 !== undefined ? obj.val_4 : '-';
      newObj['gdType'] = obj.gdType;
      newObj['gdCode'] = obj.gdCode;
      newObj['startDate'] = df(this.state.startDate, 'yyyy-mm-dd');
      newObj['endDate'] = df(this.state.endDate, 'yyyy-mm-dd');
      dataSource.push(newObj);
    });
    this.setState({ data3: dataSource });
  }

  // 绘制报表-- 猪只阶段成本
  parseStageCostData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasStageCostData: false });
      return;
    }
    this.setState({ hasStageCostData: true });

    this.drawStageCostReport(data);
  }

  drawStageCostReport = (data) => {
    let chart = this.stageChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode1',
        plugins: require('@antv/f2/lib/plugin/pie-label'),
        pixelRatio: window.devicePixelRatio
      });
    }

    this.stageChart = chart;

    chart.source(data);

    // 计算总数量
    var total = 0;
    data.map((obj) => {
      total += obj.val;
    });

    chart.coord('polar', {
      transposed: true,
      radius: 0.78,
      innerRadius: 0.43
    });

    chart.axis(false);
    chart.tooltip(false);

    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: 50,
      itemGap: 55,
      titleStyle: {
        fill: '#666',
        fontSize: 14
      },
      marker: {
        radius: 5
      }
    });

    chart.pieLabel({
      sidePadding: 15,
      activeShape: true,
      lineHeight: 45, // 行高
      label1OffsetY: -3,
      label2OffsetY: 2,
      label1: function label1(data) {
        return {
          text: data.descLoc,
          fill: '#999',
          fontSize: 10
        };
      },
      label2: function label2(data) {
        let val = 0;
        let percent = 0;
        if (data.val > 0) {
          val = Math.round(data.val);
          percent = (data.val / total) * 100;
          percent = Math.round(percent * 100) / 100;
        }
        return {
          text: val + '元/头' + '(' + percent + '%)',
          fill: '#333',
          fontSize: 10
        };
      }
    });

    chart
      .interval()
      .position('"const"*val')
      .adjust('stack')
      .color('descLoc', function(item) {
        let color = stageToColor[item];
        return color ? color : '#1890FF';
      });
    chart.render();

    // 绘制内阴影
    var frontPlot = chart.get('frontPlot');
    var coord = chart.get('coord'); // 获取坐标系对象
    frontPlot.addShape('sector', {
      attrs: {
        x: coord.center.x,
        y: coord.center.y,
        r: coord.circleRadius * coord.innerRadius * 1.24, // 全半径
        r0: coord.circleRadius * coord.innerRadius,
        fill: '#000',
        opacity: 0.15
      }
    });
    chart.get('canvas').draw();
  };

  // 绘制报表-- 猪只期末库存单位成本
  parseStockCostData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasStockCostData: false });
      return;
    }
    this.setState({ hasStockCostData: true });

    this.drawStockCostReport(data);
  }

  drawStockCostReport = (data) => {
    let chart = this.stockChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode2',
        pixelRatio: window.devicePixelRatio
      });
    }

    this.stockChart = chart;

    this.drawReport(chart, data);
  };

  // 绘制报表-- 猪只销售成本
  parseSellCostData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasSellCostData: false });
      return;
    }
    this.setState({ hasSellCostData: true });

    this.drawSellCostReport(data);
  }

  drawSellCostReport = (data) => {
    let chart = this.sellChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode3',
        pixelRatio: window.devicePixelRatio // 指定分辨率
      });
    }

    this.sellChart = chart;

    this.drawReport(chart, data);
  };

  drawReport(chart, data) {
    let stocks = [];
    let costs = [];

    data.map((obj) => {
      stocks.push(obj.val_1);
      costs.push(obj.val_2);
    });

    let stockMax = Math.max.apply(null, stocks);
    let costMax = Math.max.apply(null, costs);

    let stockObj = { alias: '期末存栏' };
    if (!stockMax) {
      stockObj['ticks'] = [0, 400, 800, 1200, 1600, 2000];
    }

    let costObj = { alias: '单位成本' };
    if (!costMax) {
      costObj['ticks'] = [0, 200, 400, 600, 800, 1000];
    }

    const defs = {
      val_1: stockObj,
      val_2: costObj,
      descLoc: {
        formatter: function formatter(val) {
          if (val.length === 5) {
            val = val.slice(0, 3) + '\n' + val.slice(3);
          } else if (val.length === 6) {
            val = val.slice(0, 4) + '\n' + val.slice(4);
          }
          return val;
        }
      }
    };

    chart.source(data, defs);

    // 设置坐标轴
    chart.axis('val_2', {
      // 单位成本
      position: 'left',
      line: null,
      grid: F2.Global._defaultAxis.grid,
      label: (text, index, total) => {
        const cfg = {
          textAlign: 'center'
        };
        if (index === 0) {
          cfg.textAlign = 'end';
        }
        return cfg;
      }
    });
    chart.axis('val_1', {
      // 期末存栏
      position: 'right',
      grid: null,
      label: (text, index, total) => {
        const cfg = {
          textAlign: 'center'
        };
        if (index === 0) {
          cfg.textAlign = 'start';
        }
        return cfg;
      }
    });
    chart.axis('descLoc', {
      label: (text, index, total) => {
        const cfg = {
          textAlign: 'center',
          fill: '#333',
          fontSize: '10'
        };
        return cfg;
      }
    });

    // 设置图例
    var legendItems = [
      {
        name: '单位成本',
        fill: '#FE5578',
        marker: function marker(x, y, r, ctx) {
          ctx.lineWidth = 1;
          ctx.strokeStyle = ctx.fillStyle;
          ctx.moveTo(x - 3 - r - 5, y);
          ctx.lineTo(x - 3 + r + 5, y);
          ctx.stroke();
          ctx.arc(x - 3, y, 5, 0, Math.PI * 2, false);
          ctx.fill();
        }
      },
      {
        name: '期末存栏',
        marker: {
          symbol: 'circle',
          radius: 5,
          fill: '#1890FF'
        }
      }
    ];

    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: null,
      itemGap: 35,
      wordSpace: 8,
      custom: true,
      items: legendItems,
      titleStyle: {
        fontSize: 14,
        fontColor: '#666'
      },
      onClick: function(ev) {
        var item = ev.clickedItem;
        var name = item.get('name');
        var checked = item.get('checked');
        var children = item.get('children');
        if (checked) {
          var markerFill = children[0].attr('fill');
          var textFill = children[1].attr('fill');
          children[0].set('_originColor', markerFill); // 缓存 marker 原来的颜色
          children[1].set('_originColor', textFill); // 缓存文本原来的颜色
        }
        var geoms = chart.get('geoms');
        for (var i = 0; i < geoms.length; i++) {
          var geom = geoms[i];
          if (geom.getYScale().alias === name)
            if (!checked) {
              geom.show();
              children[0].attr('fill', children[0].get('_originColor'));
              children[1].attr('fill', children[1].get('_originColor'));
            } else {
              geom.hide();
              children[0].attr('fill', '#bfbfbf'); // marker 置灰
              children[1].attr('fill', '#bfbfbf'); // 文本置灰 置灰
            }
          item.set('checked', !checked);
        }
      }
    });

    // 设置tooltip
    chart.tooltip({
      showCrosshairs: false,
      showItemMarker: true,
      crosshairsType: 'rect',
      tooltipMarkerStyle: {
        type: 'rect'
      },
      background: {
        radius: 6,
        padding: [6, 10]
      },
      onShow: function onShow(ev) {
        ev.tooltipMarkerCfg.type = 'rect';
      }
    });

    chart.guide().text({
      position: ['0%', '0%'],
      content: '单位成本',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart.guide().text({
      position: ['100%', '0%'],
      content: '期末存栏',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart
      .interval()
      .position('descLoc*val_1')
      .color('#1890FF')
      .size(15);
    chart
      .line()
      .position('descLoc*val_2')
      .shape('smooth')
      .color('#FE5578');
    chart
      .point()
      .position('descLoc*val_2')
      .color('#FE5578')
      .style({
        fill: '#fff',
        lineWidth: 1
      });

    chart.render();
  }

  doSearch = (start, end) => {
    already = 0;
    Toast.loading('加载中...', 0);

    let y1 = start.getFullYear();
    let m1 = start.getMonth();
    let firstDay = new Date(y1, m1, 1);
    let startDate = df(firstDay, 'yyyy-mm-dd');

    let y2 = end.getFullYear();
    let m2 = end.getMonth();
    let lastDay = new Date(y2, m2 + 1, 0);
    let endDate = df(lastDay, 'yyyy-mm-dd');

    let title = `${df(start, 'yyyy-mm')} 至 ${df(end, 'yyyy-mm')}`;

    this.setState({
      startDate,
      endDate,
      dateExtra: title
    });

    this.getStageCostData(startDate, endDate);
    this.getStageCostTableData(startDate, endDate);

    this.getStockCostData(startDate, endDate);
    this.getStockCostTableData(startDate, endDate);

    this.getSellCostData(startDate, endDate);
    this.getSellCostTableData(startDate, endDate);
  };

  getDate = () => {
    send({
      url: '/api/ifarm/v1/swine/edit_table_time',
      method: 'POST'
    }).then((res) => {
      let startDate = res.data.period;
      let month = new Date(startDate).getMonth() - 1; // 9月月结，这里要设置为 8月
      startDate = new Date(startDate).setMonth(month);
      this.setState({
        startDate,
        endDate: startDate
      });
      this.doSearch(new Date(startDate), new Date(startDate));
    });
  };
  async componentDidMount() {
    window._czc.push(['_trackEvent', '进入成本分析页面']);
    this.getDate();
    //  从成本核算进入此处。会多处几个按钮，用于重新核算成本
    let history = await send({
      url: '/api/forward/ifarm/getGeneralCostHistoryMonth',
      method: 'GET'
    });
    history = history.data;
    if (history.length > 0) {
      history = history[0].monthStr;
    } else {
      history = '';
    }
    const fromCostAccount = this.props.location.state;
    if (fromCostAccount) {
      // 先查异常信息
      this.setState(
        {
          showCostAccount: true,
          counting: false,
          current: history
        },
        () => {
          if (history) {
            this.checkResult();
          }
        }
      );
    }
  }

  componentDidUpdate() {
    if (already === 6) {
      Toast.hide();
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
    window.clearInterval(this.time);
  }
  doCount = () => {
    const { current } = this.state;
    send({
      url: '/api/forward/ifarm/saveCost',
      method: 'POST',
      data: {
        method: 'H',
        month: [current]
      }
    }).then((res) => {
      if (res.status === 200) {
        auth.setToCookie('JOBNAME', res.data.jobName);
        this.testRunning();
      }
    });
  };
  checkResult = () => {
    return send({
      url: '/api/forward/ifarm/check_result',
      method: 'POST',
      data: {
        month: this.state.current
      }
    }).then((res) => {
      this.setState({
        resultMsg: res.data
      });
    });
  };
  queryErrorMsg = () => {
    // 展示异常数据
    this.setState({
      modalShow: true,
      modalContent: (
        <div style={{ color: '#000', fontSize: 14, textAlign: 'left' }}>
          <NavBar mode={'light'}>异常信息</NavBar>
          <div style={{ margin: '0 10px', fontWeight: 600, wordBreak: 'break-word' }}>
            以下单据存在数据录入异常，可能会影响您的成本数据
          </div>
          <ol style={{ margin: 0, padding: '8px 25px' }}>
            {this.state.resultMsg.map((o, index) => {
              return (
                <li key={o + index} style={{ height: 40 }}>
                  {o}
                </li>
              );
            })}
          </ol>
        </div>
      )
    });
  };
  testRunning = () => {
    this.setState({
      counting: true
    });
    this.time = window.setInterval(() => {
      // 检查是否job 在运行
      this.reqJobStatus().then((res) => {
        // 没有运行的话，就停下轮询
        if (!res.running) {
          console.log('核算完成');
          window.clearInterval(this.time);
          auth.setToCookie('JOBNAME', '');
          this.setState(
            {
              counting: false
            },
            () => {
              this.checkResult();
            }
          );
        } else {
          this.setState({
            counting: true
          });
        }
      });
    }, 10 * 1000);
  };
  reqJobStatus = async () => {
    let res = await send({
      url: '/api/forward/ifarm/testrun',
      method: 'GET',
      params: {
        jobName: auth.getCookie('JOBNAME')
      }
    });
    return res.data;
  };
  renderCostBtn = () => {
    const { current } = this.state;
    const currentMonth = this.state.current.substr(5, 2);
    return (
      <Flex
        style={{
          width: '100vw',
          height: 50,
          position: 'fixed',
          left: 0,
          bottom: 0,
          zIndex: 1,
          backgroundColor: '#fff'
        }}
      >
        <Button
          type={'warning'}
          disabled={!current}
          style={{ fontSize: 10, width: '50vw' }}
          onClick={() => {
            // 核算该月份数据。
            this.doCount();
          }}
        >
          数据有误,重新计算{currentMonth}月份成本
        </Button>
        <Button
          type={'primary'}
          disabled={!current}
          style={{ fontSize: 10, width: '50vw' }}
          onClick={() => {
            this.queryErrorMsg();
          }}
        >
          {currentMonth}月异常数据
        </Button>
      </Flex>
    );
  };
  doCostAccount = () => {
    //  此时要对 x 月的数据做核算。
    this.setState({ counting: true });
  };
  renderWarning = () => {
    const str1 = '您还没有达成合作哦';
    const str2 = '目前只能预览，达成合作后就可以使用它啦！';
    const btn1 = '我要合作';
    return (
      <div className="warning-wrap">
        <div className="child" onClick={() => {}}>
          <div className="child-content">
            <section style={{ padding: '25px 0 15px', textAlign: 'center', fontSize: '0.4rem', fontWeight: 500 }}>
              {str1}
            </section>
            <section style={{ textAlign: 'center', fontSize: '0.3rem', fontWeight: 100 }}>{str2}</section>
          </div>
          <div className="child-footer">
            <div
              className="left"
              onClick={() => {
                this.setState({
                  showWarning: false
                });
              }}
            >
              我再看看
            </div>
            <div
              className="right"
              onClick={() => {
                this.props.history.replace('/cooperate');
              }}
            >
              {btn1}
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderMask = () => {
    return (
      <div className={'mask'} style={{ backgroundColor: 'rgba(255,255,255,0.6)', paddingTop: '250px' }}>
        <section
          onClick={() => {
            this.props.history.replace('/cooperate');
          }}
          style={{
            backgroundColor: '#108ee9',
            lineHeight: '32px',
            color: '#fff',
            textAlign: 'center',
            padding: '10px 0',
            width: 240,
            margin: '0 auto',
            borderRadius: '5px'
          }}
        >
          <section>合作后查看全部成本报表</section>
          <section style={{ fontSize: 18 }}>申请合作</section>
        </section>
      </div>
    );
  };

  render() {
    const currentMonth = this.state.current.substr(5, 2);
    return (
      <React.Fragment>
        <div className={'oneH'}>
          <List.Item
            arrow="horizontal"
            className="span-4"
            extra={this.state.dateExtra}
            onClick={() => {
              this.setState({ visible: true });
            }}
          >
            选择日期
          </List.Item>
          <DatePicker
            defaultValues={[this.state.startDate, this.state.endDate]}
            mode={'month'}
            onCancel={() => {
              this.setState({ visible: false });
            }}
            onConfirm={(start, end, type) => {
              let startDate = type === 'week' ? start.startDate : start;
              let endDate = type === 'week' ? end.endDate : end;

              this.setState({
                visible: false,
                startDate,
                endDate
              });

              this.doSearch(startDate, endDate);
            }}
            visible={this.state.visible}
          />
          <List renderHeader={() => ''}>
            <span className="title">阶段成本</span>
            {this.state.hasStageCostData ? (
              <canvas id="mountNode1" height={310} width={clientWidth} />
            ) : (
              <EmptyReport height={310} width={clientWidth} />
            )}
            <Table data={this.state.data1} columns={this.state.columns1} />
          </List>
          <List renderHeader={() => ''}>
            {window.$farmFlag && Number(window.$farmFlag) === 15 && this.renderMask()}
            <span className="title">猪只期末库存单位成本</span>
            {this.state.hasStockCostaData ? (
              <canvas id="mountNode2" height={canvasHeight} width={clientWidth} />
            ) : (
              <EmptyReport height={canvasHeight} width={clientWidth} />
            )}
            <Table data={this.state.data2} columns={this.state.columns2} />
          </List>
          <List renderHeader={() => ''}>
            {window.$farmFlag && Number(window.$farmFlag) === 15 && this.renderMask()}
            <span className="title">猪只销售成本</span>
            {this.state.hasSellCostData ? (
              <canvas id="mountNode3" height={canvasHeight} width={clientWidth} />
            ) : (
              <EmptyReport height={canvasHeight} width={clientWidth} />
            )}
            <Table data={this.state.data3} columns={this.state.columns3} />
          </List>
          <WhiteSpace size="xl" />

          {/*从成本核算来*/}
          {this.state.showCostAccount ? (
            <div>
              <WhiteSpace size="xl" />
              <WhiteSpace size="xl" />
              <WhiteSpace size="xl" />
              {this.state.counting ? (
                <React.Fragment>
                  <div
                    style={{
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      right: 0,
                      zIndex: 999,
                      height: 'calc(100vh - 75px)',
                      backgroundColor: 'rgba(0,0,0,.3)'
                    }}
                  />
                  <div
                    style={{
                      width: '100vw',
                      height: 55,
                      position: 'fixed',
                      left: 0,
                      bottom: 0,
                      zIndex: 1,
                      backgroundColor: '#fd6c6c',
                      fontSize: 10,
                      padding: '10px 0'
                    }}
                  >
                    <div style={{ textAlign: 'center' }}>
                      <b>{currentMonth}月份成本计算中...</b>
                    </div>
                    <div style={{ textAlign: 'center', color: '#fff', padding: '10px 0' }}>
                      成本计算根据场规模不同，大概需要5-30分钟
                    </div>
                    <div style={{ textAlign: 'center', color: '#fff' }}>
                      您可先退出界面，计算完成后将会展示最新的成本报表
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                this.renderCostBtn()
              )}
            </div>
          ) : null}
        </div>
        {/*弹出层公用模态框、*/}
        <Modal
          animationType="slide-up"
          maskClosable={false}
          closable
          onClose={() => {
            this.setState({
              modalShow: false
            });
          }}
          popup
          visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
        {this.state.showWarning && this.renderWarning()}
      </React.Fragment>
    );
  }
}

export default CostAnalysis;
